<template>
  <footer id="bizFooter">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 margin-bottom-8">
          <h5 class="footer-title">주식회사 해줌</h5>
        </div>
        <div class="col-xs-12 margin-bottom-8">
          <address>본사: 서울시 송파구 법원로 128 SKV1 GL 메트로시티 A동 706호 | 연구소: 서울시 송파구 법원로 128 SKV1 GL 메트로시티 A동 708호</address>
          <address>유럽법인: Haezoom Europe GmbH, (C/O St. Oberholz) Rosenthaler Straße 72a, 10119 Berlin., Germany</address>
        </div>
        <div class="col-xs-12 word-break-keep-all margin-bottom-40">
          <h5 class="footer-info">대표이사: 권오현 | 사업자번호 134-87-00089 | Tel. 02-889-9941 | Fax. 02-6455-0260</h5>
        </div>
        <div class="col-xs-12 row">
          <div class="col-sm-4 col-xs-12 footer-logo">
            <img src="~@/assets/img/logo-biz-gray.png" height="14">
          </div>
          <div class="col-sm-8 col-xs-12 footer-link">
            <ul style="display: inline-block;">
              <!--<li><a class="text-bold" :href="baseUrl + '/terms/'" target="_blank">이용약관</a></li>-->
              <li><a class="text-bold" href="https://biz.haezoom.com/media/terms/bizhaezoom_terms_2020.pdf" target="_blank">이용약관</a></li>
              <li><a class="text-bold" :href="baseUrl + '/privacy/'" target="_blank"><span class="item-bar">|</span>개인정보취급방침</a></li>
<!--              <li><a href="https://www.haezoom.com/cscenter/remote/"target="_blank"><span class="item-bar">|</span>원격지원</a></li>-->
              <li><router-link to="/cscenter"><span class="item-bar">|</span>고객센터</router-link></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'biz-footer',
    data: function () {
      return {
        baseUrl: location.protocol + '//' + location.hostname
      }
    }
  }
</script>

<style lang="scss" scoped>
  #bizFooter {
    padding: 52px 0;
    border-top: 1px solid $border-color;

    .col-xs-12 {
      padding: 0 16px;
    }

    h5, address {
      margin: 0;
      font-style: normal;
      font-stretch: normal;
    }

    .footer-title {
      font-size: 12px;
      font-weight: bold;
      line-height: 2;
      letter-spacing: -1px;
      color: #98a1a8;
    }

    address {
      font-size: 12px;
      line-height: 2;
      letter-spacing: -0.7px;
      color: #98a1a8;
    }

    .footer-info {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: -0.8px;
      color: #2e3134;
    }

    .footer-logo {
      padding: 0;

      @media (max-width: 767px) {
        text-align: center;
        margin-bottom: 32px;
      }
    }

    .footer-link {
      padding: 0;
      text-align: right;
      @media (max-width: 767px) {
        margin-bottom: 16px;
        text-align: center;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        float: left;
        a {
          font-size: 14px;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.14;
          letter-spacing: -0.8px;
          color: #2e3134;
        }
        .item-bar {
          margin: 0 4px;
          display: inline-block;
          font-weight: normal;
          width: 1px;
        }
      }
    }

    .text-bold {
      font-weight: bold;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/BizFooter.vue